import { useMemo, useState } from "react"
import { ProgressNotification } from "routes/asset-register/plugins/asset-mapping/plugins/ai-find-schedules/server/progress-notification.mjs"
import { RefiningTypes } from "library/server-event-definitions/shared-events.mjs"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { Message } from "routes/asset-register/plugins/asset-mapping/message"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { useInterval } from "lib/@hooks/useInterval"
import { useTarget } from "lib/@hooks/use-target"
import { uniqueId } from "library/database/split-id.mjs"
import { If } from "lib/@components/switch.js"

export function StatusMessages({ numberToShow = 3, messageTimeout = 30000 }) {
    const [messages, setMessages] = useState([])
    const refresh = useRefresh(noChange)
    const target = useTarget()
    useInterval(refresh, 1000)
    ProgressNotification.useEvent(
        (message, id) => {
            if (uniqueId(id) === uniqueId(target?._id)) {
                setMessages((messages) => [...messages, { time: new Date(), message }])
            }
        },
        [target?._id]
    )
    RefiningTypes.useEvent(
        (id, isRefining) => {
            if (!isRefining && uniqueId(id) === uniqueId(target?._id)) {
                setMessages([])
            }
        },
        [target?._id]
    )
    const display = useMemo(
        () => messages.filter((f) => Date.now() - f.time < messageTimeout),
        [messages, messageTimeout]
    )
    return (
        <If value={display.length > 0}>
            <TableContainer>
                <Table size="small">
                    {numberToShow > 2 && (
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 0 }}>Time</TableCell>
                                <TableCell>Message</TableCell>
                            </TableRow>
                        </TableHead>
                    )}
                    <TableBody>
                        <Repeat list={display.slice(-numberToShow)} item={<Message />} />
                    </TableBody>
                </Table>
            </TableContainer>
        </If>
    )
}
